import { Box, Button, IconButton  } from '@mui/material'
import React, { useState, useRef } from 'react'
import ReactPlayer from 'react-player'
import { MenuIcon } from '../../../../../core/icon/__refactored/Icon'
import { PlayArrow, Pause } from '@mui/icons-material';
import { useEffect } from 'react';
import { rqx } from '../../../../../core/request/API';
import { env } from '../../../../../core/Env';
import { useSnackbar } from '../../../../../core/context/SnackbarContext';

export const VL = ({openWidth, wideHandler, uid, nav, information_state,cid, getNextIncompleteStep, tool_state}) => {
    const { showSnackbar } = useSnackbar();
    let urlParams = new URLSearchParams(window.location.search);
    const [showOverlay, setShowOverlay] = useState(false);
    const [dsbld, setDsbld] = useState(true);
    const [playing, setPlaying] = useState(false);
    const [link, setlink] = useState('');
    const playerRef = useRef(null);
    const trainingId = parseInt(urlParams.get("id"), 10);

    const onPause = (e) => {
      setShowOverlay(true);
    };
  
    const onPlay = (e) => {
      setShowOverlay(false);
    };

    const handlePlayPause = () => {
        setPlaying(!playing);
    };

    const onEnded = async() => {
        const init = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_vl_create`, {training_id:trainingId, user_id:uid, exam_type:4, company_id: tool_state.cinfo.data[0].company_id})
        if(init.message === 'success') {
            setDsbld(false);
        }
    };

    const handleNext = async() => {
        // eslint-disable-next-line
        try {
            await rqx.post(`<<tool>>/${env()}/biz_exam/user_update_status`, {training_id:trainingId, user_id:uid, company_id: tool_state.cinfo.data[0].company_id})
            const init = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_vl_create`, {training_id:trainingId, user_id:uid, exam_type:4, company_id: tool_state.cinfo.data[0].company_id})
            
            if(init.message === 'success') {
                nav.push(`/biz/take-course/quiz?id=${trainingId}&cid=${cid}`)
            }
        } catch (err) {
            showSnackbar("Something went wrong!", "error");
        }
    };

    const _init = async () => {
        const courseData = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_view_course`, { course_id: cid, company_id: tool_state.cinfo.data[0].company_id });
        const trainingIdList = courseData[0].trainings.map(t => t.training_id);
        const allTrainingIds = trainingIdList.join(',');
        const init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_VL`, { training_id: trainingId, ref:'course', company_id: tool_state.cinfo.data[0].company_id });
        const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {training_id: allTrainingIds,user_id: uid,ref: 'course',course_id: cid, company_id: tool_state.cinfo.data[0].company_id});
        const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {training_id: allTrainingIds,ref: 'course'});
        const updatedProg = { pretest: 0, vl: 0, quiz: 0, posteval: 0 };

        console.log(updatedProg)
        progress.filter(item => item.training_id === trainingId).forEach(item => {
            if (item.exam_type === 1) updatedProg.pretest = 1;
            else if (item.exam_type === 4) updatedProg.vl = 1;
            else if (item.exam_type === 2) updatedProg.quiz = 1;
            else if (item.exam_type === 3) updatedProg.posteval = 1;
        });
        information_state.prog.set(updatedProg);
        const thisContent = tContent.find(t => t.training_id === trainingId);
        information_state.tc.set({
            ...information_state.tc.data,
            pretest: thisContent?.pretest_id !== null ? 1 : null,
            quiz: thisContent?.quiz_id !== null ? 1 : null,
            posteval: thisContent?.post_evaluation_id !== null ? 1 : null
        });
        const nextStep = getNextIncompleteStep(trainingId, tContent, progress);
        console.log(nextStep)
        if (nextStep && nextStep !== 'video-lesson') {
            return nav.push(`/biz/take-course/${nextStep}?id=${trainingId}&cid=${cid}`);
        }
        const currentIndex = trainingIdList.findIndex(id => id === trainingId);
        const nextTrainingId = trainingIdList[currentIndex + 1];
        if (updatedProg.vl === 1 && nextStep === null && nextTrainingId) {
            return nav.push(`/biz/take-course/video-lesson?id=${nextTrainingId}&cid=${cid}`);
        }
        setlink(init);
    };

    useEffect(() => {
        information_state.test.set({ ...information_state.test.data, name: 'Video Lesson' });
        _init();
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                e.preventDefault();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    

    return (
        <Box p="40px" display="flex" flexDirection="column" width="100%" height="100%">
            <Box display="flex" justifyContent="flex-end" alignItems="center" mb="24px">
                { !openWidth.data && (
                    <Box display="flex" className='c-pointer' onClick={wideHandler}>
                        <MenuIcon />
                        <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1" ml="12px">Show menu</Box>
                    </Box>
                    )
                }
            </Box>

            <Box className="player-wrapper" position="relative">
                {showOverlay && <Box className="player-overlay-morevdo"></Box>}
                <ReactPlayer
                ref={playerRef}
                url={link.video_link}
                playing={playing}
                onPlay={onPlay}
                onPause={onPause}
                controls={true}
                // controls={false}
                onEnded={onEnded}
                width="100%"
                height="505px"
                />
                <Box position="absolute" bottom="10px" left="10px">
                <IconButton onClick={handlePlayPause} color="primary">
                    {playing ? <Pause /> : <PlayArrow />}
                </IconButton>
                </Box>
            </Box>

            <Box display="flex" justifyContent="flex-end" mt="56px">
                <Box component={Button} onClick={()=>handleNext()} disabled={dsbld} variant="contained" bgcolor='#1893F1' color="primary" sx={{display:'flex', alignItems:'center', borderRadius: '6px', height:'44px', width:'80px', boxShadow: 'none'}} >Next</Box>
            </Box>
        </Box>
    )
}